export default [
    'DOPO_SET_PAJA_25',
    'SET_PAJA_25',
    'YO_KNIT_SWTER_38',
    'YOUTH_SWEATER_14',
    'KY_B_BALL_JK_19',
    'BI_HD_BLAKET_16',
    'ST_ULY_PETPIL_16',
    'DOUB_SPO_SHO_17',
    'STUFFED_PLLOW_22',
    'TOY_BASKET_27',
    'ZIP_HD_18',
    'YO_SW_18',
    'ST_PET_PILLOW_16',
    'TAPESTRY_36',
    'SW_18',
    'SWEATPANTS_19',
    'RUG_30',
    'PR_SWEATER_14',
    'PR_ZIP_HD_19',
    'PR_YO_SW_19',
    'QUILT_BED_SET_36',
    'NO_SLE_ZHD_18',
    'SHORT_HD_18',
    'QUILT_36',
    'PR_SW_19',
    'PR_QUILT_36',
    'QUILT_BOMBER_03',
    'PR_NO_SLE_ZHD_19',
    'PR_HD_19',
    'PR_FULL_ZIPHD_19',
    'PR_KID_HD_19',
    'PR_BAN_HD_19',
    'OVERSIZE_HD_18',
    'KNIT_SWEATER_38',
    'LW_BLANKET_10',
    'FL_ZIPHD_V2_18',
    'FL_ZIPHD_18',
    'HD_KID_18',
    'KID_PAJA_25',
    'HD_DRESS_18',
    'HD_BLANKET_16',
    'FULL_ZIPHD_18',
    'FL_HD_18',
    'FL_BOMBER_03',
    'CAR_NE_PILLOW_16',
    'FL_BLANKET_16',
    'CLOAK_18',
    'BEDDING_SET_36',
    'BAN_HD_18',
    'BOMBER_03',
    'B_BALL_JACKET_19',
    'EM_SW_40',
    'ADULT_PAJA_25',
    'HD_18',
    'PNC_BLANKET_43',
    'EM_SWEATSHIRT_19',
    'HOODIE',
    'SWEATSHIRT',
    'ZIP HOODIE 3D',
    'SLE_HD_18',
]